import { Injectable } from "@angular/core";
import { StorageHandlerService } from "@mobi-office-ui";

import { Router } from "@angular/router";

@Injectable({
  providedIn: "root",
})
export class GlobalService {
  constructor(
    private storageHandlerService: StorageHandlerService,
    private router: Router
  ) {}

  IMAGE_REGEX = /^image\/(?!x-)(?:png|jpe?g|gif|bmp|webp)$/i;
  sideSectionExpanded: boolean = true;

  onLogout() {
    this.storageHandlerService.deleteItem("token");
    this.storageHandlerService.clearAll();
    this.router.navigateByUrl("/login", { replaceUrl: true });
    setTimeout(() => {
      window.location.reload();
    }, 500);
  }
}
